import React, { Fragment, PureComponent } from 'react';
import { RouteComponentProps } from 'react-router';
import { Container } from 'semantic-ui-react';
import { PLATFORM_RUNS_QUERY } from '../../apollo';
import { RunTableCol, SortDir } from '../../types';
import { PlatformSegment } from '../HeaderSegments';
import RunTable from '../RunTable';
import Ad from '../Shared/Ad';

const cols: RunTableCol[] = [
  RunTableCol.Vods,
  RunTableCol.GameNoYear,
  RunTableCol.Year,
  RunTableCol.Category,
  RunTableCol.Genre,
  RunTableCol.Event,
  RunTableCol.Runners,
  RunTableCol.Time,
];

interface MatchParams {
  id: string;
}

interface Props extends RouteComponentProps<MatchParams> {}

class PlatformPage extends PureComponent<Props> {
  public render() {
    const { match } = this.props;
    return (
      <Fragment>
        <PlatformSegment platformId={match.params.id} />
        <Container>
          <Ad key="PlatformPage" />
          <RunTable
            key={`platform-${match.params.id}`}
            query={PLATFORM_RUNS_QUERY}
            queryVars={{ platform: match.params.id }}
            defaultSortCol={RunTableCol.GameNoYear}
            defaultSortDir={SortDir.Ascending}
            cols={cols}
          />
        </Container>
      </Fragment>
    );
  }
}

export default PlatformPage;
export { PlatformPage };
